var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductOptionDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.445 13.822C22.445 14.0775 22.3948 14.3305 22.2971 14.5666C22.1994 14.8026 22.0562 15.0172 21.8755 15.1979C21.6949 15.3786 21.4805 15.522 21.2445 15.6199C21.0084 15.7177 20.7555 15.7681 20.5 15.7682C20.2445 15.7683 19.9914 15.718 19.7554 15.6203C19.5193 15.5226 19.3047 15.3794 19.124 15.1988C18.9433 15.0182 18.7999 14.8037 18.7021 14.5677C18.6042 14.3317 18.5538 14.0787 18.5537 13.8232C18.5535 13.3072 18.7584 12.8122 19.1231 12.4473C19.4879 12.0823 19.9827 11.8771 20.4987 11.877C21.0147 11.8768 21.5097 12.0816 21.8747 12.4464C22.2397 12.8111 22.4448 13.3059 22.445 13.822Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 22.4447C21.5741 22.4447 22.4449 21.5739 22.4449 20.4997C22.4449 19.4255 21.5741 18.5547 20.4999 18.5547C19.4257 18.5547 18.5549 19.4255 18.5549 20.4997C18.5549 21.5739 19.4257 22.4447 20.4999 22.4447Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 29.1224C21.5741 29.1224 22.4449 28.2516 22.4449 27.1774C22.4449 26.1032 21.5741 25.2324 20.4999 25.2324C19.4257 25.2324 18.5549 26.1032 18.5549 27.1774C18.5549 28.2516 19.4257 29.1224 20.4999 29.1224Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOptionDetail);
export default __webpack_public_path__ + "static/media/ProductOptionDetail.38b4a27176c0a6257667c44b3bc91c59.svg";
export { ForwardRef as ReactComponent };